import React from "react";
import styles from "./UiPrimitives.module.css";

const UiFieldShell = ({
  label,
  required = false,
  helpText,
  children,
  className,
  labelClassName,
}) => {
  return (
    <div className={[styles.fieldShell, className].filter(Boolean).join(" ")}>
      {label && (
        <div className={[styles.fieldLabel, labelClassName].filter(Boolean).join(" ")}>
          {label}
          {required && <span className={styles.requiredMark}>*</span>}
        </div>
      )}
      {children}
      {helpText && <div className={styles.fieldHelp}>{helpText}</div>}
    </div>
  );
};

export default UiFieldShell;
